import React from "react";
import "./home.css";
import womanStatue from "../../assets/img/woman-with-scales_gradient.png";
import planeGlobe from "../../assets/img/plane-and-globe-2.png";
import founder from "../../assets/img/owner.png";
import CTAButton from "../../ui/CTAButton";
import ServiceCard from "../../components/serviceCard";
import whyImage from "../../assets/img/BASAH-COIN-COURT-LAWYERES.png";
import ScrollToTop from "../../components/ScrollToTop";
import { ContactSection } from "../../components";
import PopupFormModal from "../../components/popup-form/PopupForm";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import {
  useHeroSection,
  useAboutSection,
  useFounderSection,
  useServicesSection,
  useTestimonialSection,
  useWhyChooseUsSection,
} from "../../hooks/homeSectionHooks";
import { PortableText } from "@portabletext/react";
import { urlFor } from "../../lib/sanity";
import { portableTextComponents } from "../../components/PortableTextComponents";

const Home = () => {
  const {
    heroSection,
    loading: heroLoading,
    error: heroError,
  } = useHeroSection();
  const {
    aboutSection,
    loading: aboutLoading,
    error: aboutError,
  } = useAboutSection();
  const {
    founderSection,
    loading: founderLoading,
    error: founderError,
  } = useFounderSection();
  const {
    servicesSection,
    loading: servicesLoading,
    error: servicesError,
  } = useServicesSection();
  const {
    testimonialSection,
    loading: testimonialLoading,
    error: testimonialError,
  } = useTestimonialSection();
  const {
    whyChooseUsSection,
    loading: whyChooseUsLoading,
    error: whyChooseUsError,
  } = useWhyChooseUsSection();

  console.log(heroSection);
  console.log("About Section:", aboutSection);
  console.log("Founder Section:", founderSection);
  console.log("Services Section:", servicesSection);
  console.log("Testimonial Section:", testimonialSection);
  console.log("Why Choose Us Section:", whyChooseUsSection);

  if (
    heroLoading ||
    aboutLoading ||
    founderLoading ||
    servicesLoading ||
    testimonialLoading ||
    whyChooseUsLoading
  )
    return <div>Loading...</div>;
  if (
    heroError ||
    aboutError ||
    founderError ||
    servicesError ||
    testimonialError ||
    whyChooseUsError
  )
    return <div>Error loading content</div>;

  // Default testimonial content
  const testimonialContent = testimonialSection || {
    testimonial:
      "Bansah & Associates is an exceptional immigration consultation firm in Ontario. Their expertise, professionalism, and dedication helped me navigate the complex immigration process smoothly. I am truly grateful for their outstanding service and highly recommend them to anyone seeking trusted immigration advice.",
    author: "Daniel James",
  };

  return (
    <>
      <section className="showcase">
        <div className="hor container">
          <div className="ver">
            <div className="header">
              <h1>
                <PortableText
                  value={heroSection?.title}
                  components={portableTextComponents}
                />
              </h1>
              <p>{heroSection?.subtitle}</p>

              <div className="d-flex">
                <PopupFormModal
                  triggerElement={
                    <CTAButton
                      link="#"
                      text="Get Started"
                      specialClass="blueBkg"
                    />
                  }
                />
                <CTAButton
                  link="/booking"
                  text="Book Now"
                  specialClass="goldBkg ml-3"
                  blank={true}
                />
              </div>
            </div>
          </div>
          <div className="ver">
            <div className="imgWrapper">
              <img
                className="image"
                src={
                  heroSection?.heroImage
                    ? urlFor(heroSection.heroImage).url()
                    : womanStatue
                }
                alt="woman with scales gradient"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="aboutSection">
        <div className="container">
          <div className="hor">
            <div className="ver">
              <div className="imgWrapper">
                <img
                  className="image"
                  src={
                    aboutSection?.image
                      ? urlFor(aboutSection.image).url()
                      : planeGlobe
                  }
                  alt="plane and globe"
                />
              </div>
            </div>
            <div className="ver">
              <div className="txtContent py-4">
                <h2 className="">{aboutSection?.title}</h2>
                <div className="mb-3">
                  <PortableText
                    value={aboutSection?.description}
                    components={portableTextComponents}
                  />
                </div>
                <CTAButton
                  link="/about-us"
                  text="Read More"
                  specialClass="whiteBkg mb-3"
                  blank={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="founder">
        <div className="container">
          <div className="hor">
            <div className="ver">
              <div className="txtContent py-5">
                <h2 className="gold mb-3">{founderSection?.title}</h2>
                <div className="mb-3">
                  <PortableText
                    value={founderSection?.description}
                    components={portableTextComponents}
                  />
                </div>
              </div>
            </div>
            <div className="ver">
              <div className="imgWrapper">
                <img
                  className="image"
                  src={
                    founderSection?.image
                      ? urlFor(founderSection.image).url()
                      : founder
                  }
                  alt="BANSAH CEO"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="servicesSection">
        <div className="container">
          <div className="header">
            <h2>{servicesSection?.title || "Our Services"}</h2>
          </div>
          <div className="serviceCards">
            <div className="hor">
              {servicesSection?.services?.slice(0, 5).map((service, index) => (
                <div className="ver" key={index}>
                  <ServiceCard
                    heading={service.title}
                    body={service.description}
                    url="/our-services"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="hor justify-content-center mt-4">
            <Link
              to="/our-services"
              className="more-link d-flex align-items-center justify-content-center"
            >
              More <IoIosArrowForward />
            </Link>
          </div>
        </div>
      </section>
      <section className="testimony">
        <div className="container">
          <div className="txtContent">
            <p>{testimonialContent.testimonial}</p>
            <div className="testifier">
              <p>- {testimonialContent.author}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="whySection">
        <div className="container">
          <div className="hor">
            <div className="ver">
              <div className="txtContent">
                <div className="header">
                  <h2>
                    {whyChooseUsSection?.title ||
                      "Why Choose Bansah and Associates?"}
                  </h2>
                </div>
                <div className="bodyContent">
                  {whyChooseUsSection?.points?.map((point, idx) => (
                    <div className="bodyContent" key={idx}>
                      <h4>{point.title}</h4>
                      <p>{point.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="ver">
              <div className="imgWrapper">
                <img
                  className="image"
                  src={whyChooseUsSection?.image?.asset?.url || whyImage}
                  alt={whyChooseUsSection?.title || "Why Choose Us"}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactSection />

      <ScrollToTop />
    </>
  );
};

export default Home;
